import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";
import { Sheet, SheetContent, SheetTitle } from "@/components/ui/sheet";
import { api } from "@/lib/api";
import { TEAL } from "@/lib/copilot";
import ChatView from "./ChatView";

export default function CopilotPanel({ hubId, testid = "ask-copilot-btn" }) {
  const [open, setOpen] = useState(false);
  const [cid, setCid] = useState(null);
  const [meta, setMeta] = useState(null);
  const [viewKey, setViewKey] = useState("new");
  useEffect(() => {
    if (open && !meta) api.get(`/organizations/${hubId}/copilot/conversations`).then(({ data }) => setMeta(data)).catch(() => setMeta({ suggestions: [] }));
  }, [open, meta, hubId]);
  const ensure = async () => { const { data } = await api.post(`/organizations/${hubId}/copilot/conversations`, {}); setCid(data.id); return data.id; };
  return (
    <>
      <button className="inline-flex min-h-[44px] items-center gap-1.5 rounded-full px-3 text-sm font-bold transition-[background-color] duration-200"
        style={{ background: `rgba(${TEAL},0.14)`, color: `rgb(${TEAL})` }} onClick={() => setOpen(true)} data-testid={testid}>
        <Sparkles className="h-4 w-4" /> <span className="hidden sm:inline">Ask Copilot</span>
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="flex w-full flex-col border-q-line bg-q-bg p-4 sm:max-w-[440px] [&>button]:hidden" data-testid="copilot-panel">
          <div className="mb-3 flex items-center justify-between">
            <SheetTitle className="flex items-center gap-2 font-display text-lg font-extrabold text-q-text"><Sparkles className="h-5 w-5" style={{ color: `rgb(${TEAL})` }} /> Copilot</SheetTitle>
            <div className="flex items-center gap-1">
              <button className="q-btn q-btn-ghost min-h-[44px] px-2 text-xs" onClick={() => { setCid(null); setViewKey(`new-${Date.now()}`); }} data-testid="copilot-panel-new">New chat</button>
              <button className="inline-flex h-11 w-11 items-center justify-center rounded-full text-q-muted hover:text-q-text" onClick={() => setOpen(false)} aria-label="Close" data-testid="copilot-panel-close"><X className="h-5 w-5" /></button>
            </div>
          </div>
          {meta && <div className="min-h-0 flex-1"><ChatView key={viewKey} hubId={hubId} cid={cid} onEnsure={ensure} suggestions={meta.suggestions} isKid={meta.is_kid} compact /></div>}
        </SheetContent>
      </Sheet>
    </>
  );
}
